import Api from '@/services/Api'

export default {
    getVigencias(){
        return Api().get('impuestos/vigencias')
    },
    getReportes(){
        return Api().get('impuestos/reportes')
    },
    getResumen(datos){
        return Api().get('impuestos/resumen', { params: datos })
    }
}